import moment from "moment";
import { statementDetails, NormalizedPayoutData, PayType } from "../types";
import { PDFHeader } from "./PDFHeader";
import { Show } from "shared/components";
import { StatementStatus } from "../../statements/types";
import { formatToCurrency } from "../../../utils/currency";

interface BillingDetailCardProps {
  statementDetails: statementDetails;
  normalizedData?: NormalizedPayoutData;
}

export const BillingDetailCard = ({
  statementDetails,
  normalizedData
}: BillingDetailCardProps) => {
  const isPayout = statementDetails.pay_type === PayType.Payout;

  return (
    <div className="pt-2 print:!px-12">
      <PDFHeader
        payType={statementDetails.pay_type}
        billingDetails={statementDetails}
        totalAmount={normalizedData?.total}
      />
      <div className="flex print:flex-col">
        <div className="hidden print:flex">
          <div className="py-2 pr-12 print:pr-0">
            <p className="print-color-adjust text-xs text-content-400 print:w-auto print:bg-alpha-40 print:px-2 print:py-1">
              Due Date
            </p>
            <p className="py-2 text-sm font-medium text-content-1000 print:px-2">
              {moment.utc(statementDetails.period.end).format("MM/DD/YY")}
            </p>
          </div>
          <div className="py-2 pr-12 print:w-auto">
            <p className="print-color-adjust text-xs text-content-400 print:bg-alpha-40 print:px-2 print:py-1 print:pl-12">
              Service Period
            </p>
            <p className="py-2 text-sm font-medium text-content-1000 print:pl-12">
              {moment.utc(statementDetails.period.start).format("MMMM YYYY")}
            </p>
          </div>
        </div>

        <div className="flex no-print">
          <div className="py-2 pr-12 print:pr-0">
            <p className="print-color-adjust text-xs text-content-400 print:w-auto print:bg-alpha-40 print:px-2 print:py-1">
              Month
            </p>
            <p className="py-2 text-sm font-medium text-content-1000 print:px-2">
              {moment.utc(statementDetails.period.start).format("MMMM YYYY")}
            </p>
          </div>
          <div className="py-2 pr-12 print:w-auto">
            <p className="print-color-adjust text-xs text-content-400 print:bg-alpha-40 print:px-2 print:py-1 print:pl-12">
              Due date
            </p>
            <p className="py-2 text-sm font-medium text-content-1000 print:pl-12">
              {moment.utc(statementDetails.period.end).format("MMM DD, YYYY")}
            </p>
          </div>
        </div>
        <div className="no-print py-2 pr-12">
          <p className="text-xs capitalize text-content-400">Type</p>
          <p className="py-2 text-sm font-medium text-content-1000">
            {statementDetails.pay_type === PayType.Payin ? "Charge" : "Payout"}
          </p>
        </div>
        <div className="no-print py-2 pr-12">
          <p className="text-xs capitalize text-content-400">Statement ID</p>
          <p className="py-2 text-sm font-medium text-content-1000">
            {statementDetails.id}
          </p>
        </div>
        <Show if={statementDetails.status === StatementStatus.Finished}>
          <div className="py-2 pr-12 print:pr-0 no-print">
            <p className="print-color-adjust text-xs text-content-400 print:bg-alpha-40 print:px-2 print:py-1">
              Payments method
            </p>
            <p className="py-2 text-sm font-medium text-content-1000 print:px-2">
              {statementDetails.bank_account?.name &&
              statementDetails.bank_account.last4
                ? `${statementDetails.bank_account.name} **** ${statementDetails.bank_account.last4}`
                : "Account for payouts is not selected"}
            </p>
          </div>
          <div className="py-2 pr-12 print:pr-0 hidden print:inline">
            <p className="print-color-adjust text-xs text-content-400 print:bg-alpha-40 print:px-2 print:py-1">
              Payments
            </p>
            <p className="py-2 text-sm font-medium text-content-1000 print:px-2">
              {statementDetails.bank_account?.name &&
              statementDetails.bank_account.last4
                ? `${formatToCurrency({
                    cents: Math.abs(normalizedData?.total || 0) || 0,
                    currency: "USD"
                  })} was paid ${
                    statementDetails.sending_at || statementDetails.paid_at
                      ? "on " +
                        moment
                          .utc(
                            isPayout
                              ? statementDetails.sending_at
                              : statementDetails.paid_at
                          )
                          .format("DD MMM, YYYY HH:mm z")
                      : ""
                  } by ${statementDetails.bank_account.name} **** ${statementDetails.bank_account.last4} Bank Account`
                : "Account for payouts is not selected"}
            </p>
          </div>
          <div className="no-print py-2">
            <p className="text-xs text-content-400">Paid on</p>
            <p className="py-2 text-sm font-medium text-content-1000">
              {statementDetails.sending_at || statementDetails.paid_at
                ? moment
                    .utc(
                      isPayout
                        ? statementDetails.sending_at
                        : statementDetails.paid_at
                    )
                    .format("MMM DD, YYYY")
                : "--"}
            </p>
          </div>
        </Show>
      </div>
    </div>
  );
};
